import { render } from "./CIS-Steps-Carousel.vue?vue&type=template&id=6c744ecb&scoped=true"
import script from "./CIS-Steps-Carousel.vue?vue&type=script&lang=js"
export * from "./CIS-Steps-Carousel.vue?vue&type=script&lang=js"

import "./CIS-Steps-Carousel.vue?vue&type=style&index=0&id=6c744ecb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c744ecb"]])

export default __exports__